import { type ComputedRef } from "vue"
import type { RouteLocationRaw } from "vue-router"
import {
  priorBenefitsCompleteOrRedirect,
  type BarEntry,
  type EnrollmentSegment
} from "@/modules/enrollment-new/enrollment-segments"
import { useStepperSegments } from "@/modules/enrollment-new/pages/enrollment-flow/composables/useStepperSegments"

export interface UseStepperBar {
  bar: ComputedRef<BarEntry[]>
  segments: ComputedRef<EnrollmentSegment[]>
  currentBarIndex: ComputedRef<number>
  isClickable: (barIndex: number) => boolean
  routeForBar: (barIndex: number) => RouteLocationRaw
}

export function useStepperBar(): UseStepperBar {
  const { segments, bar, currentBarIndex } = useStepperSegments()

  function isClickable(barIndex: number): boolean {
    if (barIndex >= currentBarIndex.value) return false
    const entry = bar.value[barIndex]
    if (!entry) return false
    return priorBenefitsCompleteOrRedirect(segments.value, entry.firstSegmentIndex) === true
  }

  function routeForBar(barIndex: number): RouteLocationRaw {
    const entry = bar.value[barIndex]
    if (!entry) return bar.value[0]?.route ?? { name: "enroll:background" }
    return entry.route
  }

  return { bar, segments, currentBarIndex, isClickable, routeForBar }
}
